import React from 'react';
import { useTranslation } from 'react-i18next';

import { SelectLocationCard } from '../../../../../common/SelectLocationCard';
import { ProviderLocation } from '../../../../../models/ProviderDetails';
import {
  ChooseLocationCardsContainer,
  ChooseLocationLabel,
  ChooseLocationRow,
  ListViewBtnContainer,
} from './ChoosePCPLocation.styled';

type Props = {
  isMobileMapView: boolean;
  providerLocations: ProviderLocation[];
  saveAndCancelButtons: React.ReactNode;
  setIsMobileMapView: (isMobileMapView: boolean) => void;
  setMobileRouteView: (isMobileMapView: boolean) => void;
  savedLocationOption?: ProviderLocation[];
  setSavedLocationOption?: (location: ProviderLocation[]) => void;
  useStickyButtonRow: boolean;
};

export const LocationsListView = ({
  isMobileMapView,
  providerLocations,
  saveAndCancelButtons,
  setIsMobileMapView,
  savedLocationOption,
  setSavedLocationOption,
  useStickyButtonRow,
}: Props) => {
  const { t } = useTranslation();
  const highlightRefs = React.useRef<any>({});

  const wrapperSelectedStyle = {
    border: '3px solid #002677',
    borderRadius: '12px',
  };

  const chooseALocationHeading = (
    <ChooseLocationRow
      data-auto-testid="choose-a-location-row"
      data-testid="choose-a-location-row"
    >
      <ChooseLocationLabel
        color="$primary1"
        cssProps={{ isListView: true }}
        display="h4"
        fontWeight="$bold"
        offset={1}
      >
        {t('CHOOSE_PCP_FLOW.CHOOSE_A_LOCATION')}
      </ChooseLocationLabel>
    </ChooseLocationRow>
  );

  return (
    <>
      {chooseALocationHeading}
      <ChooseLocationCardsContainer
        aria-label="Choose a location"
        className="choose-location-container"
        role="group"
      >
        {providerLocations?.map((location, index) => {
          const isLocationSelected = savedLocationOption?.some(
            (loc) => loc.locationId === location.locationId
          );
          const handleSelectLocation = () => {
            if (isLocationSelected) {
              setSavedLocationOption?.(
                savedLocationOption?.filter(
                  (loc) => loc.locationId !== location.locationId
                ) ?? []
              );
            } else {
              setSavedLocationOption?.([
                ...(savedLocationOption ?? []),
                location,
              ]);
            }
          };
          return (
            <div
              className="location-cards-container"
              data-auto-testid="choose-pcp-location-section"
              data-testid="choose-pcp-location-section"
              key={`pcp-location-${index + 1}`}
              style={isLocationSelected ? wrapperSelectedStyle : {}}
            >
              <SelectLocationCard
                handleDirectionClick={() => {}}
                highlightRefs={highlightRefs}
                index={index}
                isMobileMapView={isMobileMapView}
                location={location}
                selectLocation={handleSelectLocation}
                selected={isLocationSelected}
                selectedId={null}
                setIsMobileMapView={setIsMobileMapView}
                showBadgeRow
                totalLocations={providerLocations.length}
              />
            </div>
          );
        })}
      </ChooseLocationCardsContainer>
      {!useStickyButtonRow ? (
        <ListViewBtnContainer>{saveAndCancelButtons}</ListViewBtnContainer>
      ) : null}
    </>
  );
};
